import { Form, Formik } from 'formik'
import { FC, useState } from 'react'
import { MdDone, MdModeEditOutline } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import { useFormatCurrency } from '../../../../lib/CurrencyFormatter'
import Button from '../../../Formik/Button'
import Input from '../../../Formik/Input'

import * as Yup from 'yup'
type Props = {
  allowance: number
  allowanceUpdated: (allowance: number) => void
  maximumAllowance: number
}
const BalancedAllowanceColumn: FC<Props> = ({
  allowance,
  allowanceUpdated,
  maximumAllowance,
}) => {
  const { t } = useTranslation(['budget'])
  const formatCurrency = useFormatCurrency()
  const [isActive, toggleActive] = useState<boolean>(false)

  return (
    <Formik
      initialValues={{
        allowance: Math.ceil(allowance),
      }}
      enableReinitialize={true}
      validationSchema={Yup.object({
        allowance: Yup.number()
          .min(0, t('budget:balancedAllowanceColumn.min'))
          .max(
            maximumAllowance,
            t('budget:balancedAllowanceColumn.max', {
              max: maximumAllowance,
            }),
          ),
      })}
      onSubmit={(values) => {
        allowanceUpdated(values.allowance)
        toggleActive(false)
      }}
    >
      <Form>
        {isActive && (
          <div className='flex'>
            <Input name='allowance' type='number' />
            <Button size='sm' type='submit' className='ml-1'>
              <MdDone />
            </Button>
          </div>
        )}
        {!isActive && (
          <span
            onClick={() => toggleActive(true)}
            className='flex cursor-pointer'
          >
            {formatCurrency(allowance)}
            <MdModeEditOutline size='1.1rem' />
          </span>
        )}
      </Form>
    </Formik>
  )
}

export default BalancedAllowanceColumn
